/**
 * @file Warns on an unsupported browser and points the user at Google Chrome.
 *
 * Mounted by `AppShell` above whatever the route renders — the routed page
 * under `RootLayout`, or `ErrorPage` under the router's `errorElement`.
 * Renders `null` on a supported browser, so layout is pixel-identical to no
 * banner at all. `isSupportedBrowser()` runs inside render, never at module
 * scope, so a test that stubs `navigator` before mounting is honoured. Closing
 * is antd `Alert`'s own per-mount state, deliberately not persisted.
 */
import { Alert, Typography } from 'antd';

import { isSupportedBrowser } from './isSupportedBrowser';

export default function UnsupportedBrowserBanner() {
  if (isSupportedBrowser()) return null;

  return (
    <Alert
      banner
      type="warning"
      closable={{ 'aria-label': 'Dismiss browser support notice' }}
      title={
        <>
          <Typography.Text>
            This browser isn't supported. Syncretic works in Google Chrome and Safari.{' '}
          </Typography.Text>
          <Typography.Link
            href="https://www.google.com/chrome/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get Google Chrome (opens in a new tab)"
          >
            Get Google Chrome.
          </Typography.Link>
        </>
      }
    />
  );
}
